<template>
  <main
    class="region-chosen-wrapper"
    :class="[
      displayModeClassName,
      layoutVersion,
      isNewLayout ? 'new-version' : '',
      addClass ? addClass : '',
    ]"
  >
    <div :class="['flag-icon', displayMode, page]" @click="handleOpenPopup">
      <!-- 只有在俄罗斯的 PUBGM 详情页下才显示独联体旗标，且不必触发切换国家语言弹窗 -->
      <img
        v-if="isTargetPage"
        :src="require(`@/assets/images/common/flag-icon/flag_СНГ.png`)"
        alt=""
      />
      <img
        v-else
        :src="
          flagIcon
            ? require(`@/assets/images/common/flag-icon/${flagIcon}`)
            : ''
        "
        alt=""
      />
    </div>
    <van-popup
      v-model="show"
      :close-on-click-overlay="!isDesktop"
      round
      :position="isDesktop ? 'center' : 'bottom'"
      get-container="region-chosen-wrapper"
      class="region-lang-popup"
    >
      <template v-if="isDesktop">
        <DropdownList
          iconName="icon-location"
          :dataSource="regionOptions"
          :labelName="$t('common.region')"
          :currentOption="regionRadioKey"
          @selected="(val) => onSelected('region', val)"
        />
        <DropdownList
          iconName="icon-language"
          :dataSource="langsOptions"
          :labelName="$t('common.language')"
          :currentOption="langRadioKey"
          @selected="(val) => onSelected('lang', val)"
        />
        <div class="btn-wrapper flex-end">
          <button class="cancel" @click="() => (this.show = false)">
            {{ $t('common.cancle') }}
          </button>
          <button class="confirm" @click="handleOK">
            {{ $t('common.confirm') }}
          </button>
        </div>
      </template>
      <template v-else>
        <section v-if="showPanel === 1">
          <p class="title">{{ $t('common.region_lang') }}</p>
          <div class="option-list-wrapper">
            <div
              class="option-wrapper"
              v-for="(item, key) in options"
              :key="key"
              @click="handleClickOption(key)"
            >
              <span>{{
                key === 'lang' ? $t('common.language') : $t('common.region')
              }}</span>
              <div class="current-select">
                <img
                  v-if="item.icon && key === 'region'"
                  class="flag-icon"
                  :src="
                    require(`@/assets/images/common/flag-icon/${item.icon}`)
                  "
                  alt="toplupe"
                />
                <span>{{ item.value }}</span>
                <div class="goto-arrow"></div>
              </div>
            </div>
          </div>
          <button @click="handleOK" class="confirm-btn">
            {{ $t('common.save') }}
          </button>
        </section>

        <section v-if="showPanel === 'region'" class="region-options-wrapper">
          <p class="title">
            <van-icon class="back-icon" name="arrow-left" @click="handleBack" />
            {{ title }}
          </p>
          <van-radio-group v-model="regionRadioKey" class="option-wrapper">
            <van-radio
              v-for="(item, key) in regionOptions"
              :key="key"
              :name="key"
            >
              <img
                v-if="!!item.icon"
                :src="require(`@/assets/images/common/flag-icon/${item.icon}`)"
                alt="toplupe"
              />
              <span>{{ item.value }}</span>
            </van-radio>
          </van-radio-group>
        </section>

        <section v-if="showPanel === 'lang'" class="lang-options-wrapper">
          <p class="title">
            <van-icon class="back-icon" name="arrow-left" @click="handleBack" />
            {{ title }}
          </p>
          <van-radio-group v-model="langRadioKey" class="option-wrapper">
            <van-radio
              v-for="(item, key) in langsOptions"
              :key="key"
              :name="key"
            >
              <span>{{ item.value }}</span>
            </van-radio>
          </van-radio-group>
        </section>
      </template>
    </van-popup>
  </main>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { setCookie } from '@/utils/login/index'
  import { getCookie } from '@/utils/tool'
  import { getEnv, isLocalIp } from '@/utils/env'
  import { region, getDomain } from '@/utils/utils'
  import { REGION_LANG_MAP, LANG_NAME_MAP } from '@/consts'
  import { trackClickLangEntry, trackLangChanged } from './firebase'
  import { locale } from '@/utils/utils'
  import { routeContains } from '@/config/routePrefix'
  import DropdownList from './DropdownList.vue'
  import { jumpToPage } from '@/utils/utils'

  export default {
    name: 'region-lang-popup',
    components: {
      DropdownList,
    },
    props: {
      page: {
        type: String,
        defalut: '',
      },
      addClass: {
        type: String,
        defalut: '',
      },
    },
    data() {
      return {
        langBeforeChange: '',
        show: false,
        localeLang: '', // 全局语言
        localeRegion: 'ru', // 全局设置语言对应的国家
        currRegion: '', //当前所选国家的展示文案
        currLang: '', //当前所选语言的展示文案
        regionRadioKey: '', //当前所选国家对应的 key
        langRadioKey: '', //当前所选语言对应的 key
        regionOptions: {}, // 国家可选列表
        langsOptions: {}, // 语言可选列表
        initiated: false, // 标记 this.regionRadioKey 是否是在 created() 中初始化时改变的
        // 选项列表，children 代表子选项，支持多级嵌套
        title: '',
        showPanel: 1,
        subOptions: [],
        options: {
          region: {
            title: this.$t('common.regionSetting'),
            text: this.$t('common.region'),
            value: '',
            icon: '',
          },
          lang: {
            title: this.$t('common.langSetting'),
            text: this.$t('common.language'),
            value: '',
          },
        },
      }
    },
    computed: {
      ...mapState(['region', 'layoutVersion', 'isDesktop']),
      ...mapGetters(['displayMode', 'displayModeClassName', 'isNewLayout']),
      flagIcon() {
        return REGION_LANG_MAP[this.localeRegion.toUpperCase()]?.icon
      },
      currentPage() {
        const {
          params: { gameName = '' },
        } = this.$route
        return gameName || 'home'
      },
      isTargetPage() {
        return this.region === 'ru' && this.currentPage === 'pubgm'
      },
    },
    watch: {
      regionRadioKey(val) {
        this.currRegion = REGION_LANG_MAP[val]?.value || ''
        this.options['region'].value = this.currRegion || ''
        this.options['region'].icon = REGION_LANG_MAP[val]?.icon || ''
        if (!this.initiated) {
          // 确保初始化时展示的所选语言是当前设置的国家和语言
          // 手动选择地区的时候，当前展示的语言也随之变化
          this.langRadioKey = REGION_LANG_MAP[val]?.langs[0] //默认取第一个
        }
        this.initiated = false //为 false 时代表手动切换
        this.showPanel = 1
      },
      langRadioKey(val) {
        this.currLang = LANG_NAME_MAP[val]
        this.options['lang'].value = this.currLang
        this.showPanel = 1
      },
      show(val) {
        if (
          !val &&
          this.localeLang === `${this.langRadioKey}_${this.regionRadioKey}`
        ) {
          // 跳过点击 OK 确认弹窗关闭的情况
          return
        }
        if (!val) {
          // 只要用户点击切换国家或语言后没按 OK 就关闭弹窗
          this.initStatus()
        }
      },
    },
    methods: {
      handleOpenPopup() {
        if (this.isTargetPage) {
          return
        }
        this.show = true
        trackClickLangEntry({ page: this.currentPage })
      },
      initStatus() {
        // 用于恢复展示当前所选国家与语言
        const strArr = this.localeLang.split('_')
        this.langRadioKey = strArr[0] // 语言简称，小写
        this.regionRadioKey = strArr[1] // 国家简称，大写
        this.showPanel = 1
        this.initiated = true
        this.langsOptions = REGION_LANG_MAP[this.regionRadioKey].children
      },
      storeLocaleLang() {
        const hostname = window.location.hostname
        let domain = ''
        if (hostname === 'localhost' || isLocalIp()) {
          domain = hostname
        } else {
          domain = getDomain()
        }
        setCookie('localeLang', this.localeLang, 30, domain)
      },
      handleOK() {
        this.localeLang = this.langRadioKey + '_' + this.regionRadioKey
        this.localeRegion = this.regionRadioKey.toLowerCase()
        this.langBeforeChange = getCookie('localeLang')
        this.storeLocaleLang()
        this.$root.$i18n.locale = this.localeLang // 同步设置全局语言
        this.show = false

        if (this.localeRegion !== region()) {
          // 上报切换语言埋点
          trackLangChanged({
            page: this.page,
            country_from: region(),
            country_to: this.localeRegion,
            language_from: this.langBeforeChange,
            language_to: this.localeLang,
          })
          // 只有切换国家时才改变域名
          this.switchRegion()
        }
      },
      switchRegion() {
        // 统一跳转至首页
        const { origin, search, host } = window.location
        const isProduction = getEnv() === 'online'

        // 是否增加前缀
        const isSwitchSuffix =
          getEnv() === 'test' ||
          getEnv() === 'preview' ||
          host.indexOf('www') > -1

        // 兼容：当前的域名是否为老域名；
        const isContain = routeContains(host, 2)

        const queryString = decodeURIComponent(search)
        let res = ''

        if (isSwitchSuffix) {
          // 20231214:临时处理印尼域名封禁问题，如果切换为印尼时用life域名
          // if (this.localeRegion === 'id' && isProduction) {
          //   window.location.href = `https://www.toplupe.life/id${search}`
          // } else {
          //   jumpToPage(`${origin}/${this.localeRegion}${search}`)
          // }
          jumpToPage(`${origin}/${this.localeRegion}${search}`)
          return
        }

        if (isProduction && this.localeRegion === 'th') {
          jumpToPage(`https://www.toplupe.com/th`)
          return
        }

        if (isProduction && isContain) {
          if (origin.indexOf('toplupe.com') > -1) {
            res = origin.replace(/[a-z]+(?=\.toplupe\.com)/, this.localeRegion)
          }

          if (origin.indexOf('toplupe.life') > -1) {
            res = origin.replace(/[a-z]+(?=\.toplupe\.life)/, this.localeRegion)
          }

          jumpToPage(res + queryString)
        }
      },
      handleClickOption(option) {
        this.title = this.options[option].title
        if (option === 'lang') {
          this.langsOptions =
            REGION_LANG_MAP[this.regionRadioKey]?.children || {}
        }
        this.showPanel = option
      },
      onSelected(type, key) {
        if (type === 'region') {
          this.regionRadioKey = key
          this.langsOptions =
            REGION_LANG_MAP[this.regionRadioKey]?.children || {}
        } else if (type === 'lang') {
          this.langRadioKey = key
        }
      },
      handleBack() {
        this.showPanel = 1
      },
      initLanguage() {
        this.localeLang = locale()
        const localeLangArr = this.localeLang.split('_')
        this.langRadioKey = localeLangArr[0]
        this.regionRadioKey = localeLangArr[1]
        this.localeRegion = this.regionRadioKey.toLowerCase() // 记录当前国家简称，小写，用于展示当前所选语言对应的国家国旗图片
        this.initiated = true // 标记初始变更 this.regionRadioKey
        this.initOptions()
      },
      initOptions() {
        this.regionOptions = REGION_LANG_MAP
        this.langsOptions = REGION_LANG_MAP[this.regionRadioKey]?.children
      },
    },
    mounted() {
      this.initLanguage()
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
<style scoped>
  .region-lang-popup .van-cascader >>> .van-cascader__header {
    justify-content: center;
    color: #f96000;
    font-family: Manrope-Medium, Manrope;
    font-style: normal;
  }
  .region-lang-popup
    .van-cascader
    >>> .van-cascader__header
    .van-cascader__title {
    text-align: center;
    font-weight: 800;
    font-size: 54px;
    line-height: 74px;
  }

  .van-cascader >>> .van-cascader__options {
    height: 100%;
  }

  .region-lang-popup .van-radio {
    height: 75px;
    margin-bottom: 90px;
    display: flex;
    align-items: center;
  }
  .region-lang-popup .van-radio:last-of-type {
    margin-bottom: 0;
  }
  .region-lang-popup .van-radio-group >>> .van-radio__label {
    display: flex;
    align-items: center;
    margin-left: 60px;
  }
  .region-lang-popup .van-radio-group >>> .van-radio__label > img {
    object-fit: contain;
    height: 59px;
    margin-right: 20px;
  }
  .region-lang-popup .van-radio-group >>> .van-radio__icon .van-icon {
    background-color: rgba(0, 0, 0, 0.1);
    border-width: 0;
  }
  .region-lang-popup
    .van-radio-group
    >>> .van-radio__icon.van-radio__icon--checked
    .van-icon.van-icon-success {
    border-color: rgba(249, 96, 0, 1);
    border-width: 15px;
  }
  .region-lang-popup
    .van-radio-group
    >>> .van-radio__icon
    .van-icon.van-icon-success::before {
    display: none;
  }

  /* 适配 PC */
  .display-desktop .region-lang-popup >>> .van-radio,
  .desktop .region-lang-popup >>> .van-radio {
    height: 52px;
    margin-bottom: 5px;
  }
  .display-desktop .region-lang-popup .van-radio-group >>> .van-radio__label,
  .desktop .region-lang-popup .van-radio-group >>> .van-radio__label {
    margin-left: 0px;
  }
  .display-desktop .region-lang-popup .van-radio-group >>> .van-radio__icon,
  .desktop .region-lang-popup .van-radio-group >>> .van-radio__icon {
    margin-right: 20px;
  }
  .display-desktop
    .region-lang-popup
    .van-radio-group
    >>> .van-radio__label
    > img,
  .desktop .region-lang-popup .van-radio-group >>> .van-radio__label > img {
    object-fit: contain;
    height: 22px;
    margin-right: 20px;
  }
  .display-desktop
    .region-lang-popup
    .van-radio-group
    >>> .van-radio__icon.van-radio__icon--checked
    .van-icon.van-icon-success,
  .desktop
    .region-lang-popup
    .van-radio-group
    >>> .van-radio__icon.van-radio__icon--checked
    .van-icon.van-icon-success {
    border-color: rgba(249, 96, 0, 1);
    border-width: 5px;
  }
</style>
